import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-grey-1 q-pa-lg" }
const _hoisted_2 = { class: "text-h6 q-mb-md q-mt-none" }
const _hoisted_3 = { class: "text-body1 q-mb-md" }
const _hoisted_4 = { class: "text-center q-mt-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_instructions = _resolveComponent("instructions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, [
              _createVNode(_component_q_icon, {
                name: "fa fa-lock",
                class: "on-left"
              }),
              _createTextVNode(" Connect Your " + _toDisplayString(_ctx.platform.name) + " Account ", 1)
            ]),
            _createElementVNode("div", _hoisted_3, " Click \"Get Started\" below to login to " + _toDisplayString(_ctx.platform.name) + " and import your posts. ", 1),
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }),
    _createVNode(_component_instructions, {
      platform: _ctx.platform.type,
      class: "q-my-xs"
    }, null, 8, ["platform"])
  ]))
}